import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import { errorHandler } from './error/errorHandler.action'



export const logoutAction = () => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.LOGOUT
    let logoutOptions = Object.assign({ method: 'POST'})
    logoutOptions.headers = getHeaders()
    logoutOptions.url = url
    return axios(logoutOptions).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        return resp
      } else {
        return null
      }
    }).catch(error => {
      errorHandler(error)
    })
  }